import { render, staticRenderFns } from "./SupplierOrdersView.vue?vue&type=template&id=f5d60be6&"
import script from "./SupplierOrdersView.vue?vue&type=script&lang=js&"
export * from "./SupplierOrdersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports